import { useState } from "react";
import { Box, Menu, MenuItem, ListItemText } from "@mui/material";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import CheckRounded from "@mui/icons-material/CheckRounded";

const FONT = "'Plus Jakarta Sans', 'Noto Sans Lao', system-ui, sans-serif";

// Pretty station picker: a pill button showing the current station + a chevron that
// opens a styled menu of the user's stations. `size="lg"` matches a page title.
export default function StationSwitcher({ value, options = [], onChange, size = "md" }) {
  const [anchor, setAnchor] = useState(null);
  const current = options.find((o) => o.id === value);
  const label = current?.name || value;
  const fontSize = size === "lg" ? 22 : 15;

  return (
    <>
      <Box
        component="button"
        type="button"
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          fontFamily: FONT,
          fontSize,
          fontWeight: 800,
          color: "#16131f",
          letterSpacing: "-.01em",
          background: "#fff",
          border: "1px solid #ece9f1",
          borderRadius: "12px",
          padding: size === "lg" ? "6px 10px 6px 16px" : "7px 8px 7px 14px",
          cursor: "pointer",
          boxShadow: "0 1px 2px rgba(20,18,30,.04)",
          transition: "border-color .15s, background .15s, box-shadow .15s",
          "&:hover": { borderColor: "#d9cffb", background: "#faf9fc" },
        }}
      >
        <Box component="span" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 260 }}>{label}</Box>
        <Box sx={{ width: 26, height: 26, borderRadius: "8px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f0fc", color: "#6d28d9", transition: "transform .15s", transform: anchor ? "rotate(180deg)" : "none" }}>
          <ExpandMoreRounded sx={{ fontSize: 18 }} />
        </Box>
      </Box>

      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: { mt: 0.75, p: 0.75, borderRadius: "14px", minWidth: 220, border: "1px solid #ece9f1", boxShadow: "0 1px 2px rgba(20,18,30,.05),0 16px 36px -16px rgba(20,18,30,.3)" } }}
        MenuListProps={{ sx: { py: 0 } }}
      >
        {options.map((o) => {
          const active = o.id === value;
          return (
            <MenuItem
              key={o.id}
              selected={active}
              onClick={() => { setAnchor(null); if (o.id !== value) onChange(o.id); }}
              sx={{
                borderRadius: "9px",
                my: 0.25,
                px: 1.25,
                "&.Mui-selected": { background: "#f3f0fc" },
                "&.Mui-selected:hover": { background: "#ece4fb" },
              }}
            >
              <ListItemText primary={o.name || o.id} primaryTypographyProps={{ fontFamily: FONT, fontSize: 14, fontWeight: active ? 700 : 500, color: active ? "#5b21b6" : "#2c2937" }} />
              {active && <CheckRounded sx={{ fontSize: 17, color: "#6d28d9", ml: 1.5 }} />}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
